module.exports = __webpack_public_path__ + "media/images/icons/file_attachment@2x-f35b096451c0d27a71c05a9b5f0d6df4.png";